import { useState } from 'react';
import { downloadPolicyPDF } from '../../../../api/service/superAdmin/pension-policies/service';

const usePolicyDocumentActions = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async (id: string, fileName?: string) => {
    if (!id) {
      console.error('ID is missing, cannot download file.');
      return;
    }
    setIsDownloading(true);
    try {
      const blob = await downloadPolicyPDF(id);
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const finalFileName = fileName || `policy-${id}.pdf`;
        link.setAttribute('download', finalFileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        console.error('Failed to download file: Blob was null.');
      }
    } catch (error) {
      console.error('Error during file download:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  return { isDownloading, handleDownload };
};

export default usePolicyDocumentActions;
